import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { filter } from 'lodash'
import { connect } from 'react-redux'
import AppStore from '../../../store/AppStore'
import SelectionsPanel from './SelectionsPanel'
import DtoSelection from '../../dto/DtoSelection'
import HomeAction from '../../../home/actions/HomeAction'
import i18n from 'simple-react-i18n'
import NewSelectionPanel from './NewSelectionPanel'
import { PATH_HOME } from '../../../home/constants/HomeConstants'
import { push } from 'react-router-redux'

class SelectionApp extends Component {
	componentWillMount() {
		if (this.props.isLogged) {
			AppStore.dispatch(HomeAction.setTitle(i18n.myResearch))
		} else {
			AppStore.dispatch(push(PATH_HOME))
		}
	}

	render() {
		const selections = (() => {
			if (this.props.selections.length) {
				const select = filter(this.props.selections, o => !o.close)
				if (select.length) {
					return select
				}
				return []
			}
			return []
		})()
		if (selections.length) {
			return (
				<div>
					<div className='row no-margin'>
						<div className='col s12 m12 no-padding'>
							<SelectionsPanel selections={ selections }/>
						</div>
					</div>
				</div>
			)
		}
		return (
			<div className='row no-margin'>
				<div className='col s12'>
					<NewSelectionPanel/>
				</div>
			</div>
		)
	}
}

SelectionApp.propTypes = {
	login: PropTypes.string,
	isLogged: PropTypes.bool,
	selections: PropTypes.arrayOf(PropTypes.objectOf(DtoSelection))
}

const mapStateToProps = store => {
	return {
		selections: store.SelectionReducer.selections
	}
}

export default connect(mapStateToProps)(SelectionApp)



// WEBPACK FOOTER //
// ./src/dashboard/components/selections/SelectionApp.js